import { SearchMode } from "helpers/api";
import { CreditedFeature } from "store/slices/subscription";

export function searchModeToCreditedFeature(
  searchMode: SearchMode
): CreditedFeature {
  if (searchMode === SearchMode.PRO_RESEARCH) {
    return CreditedFeature.DEEP_SEARCH;
  } else if (searchMode === SearchMode.PRO_ANALYSIS) {
    return CreditedFeature.PRO_SEARCH;
  } else {
    return CreditedFeature.QUICK_SEARCH;
  }
}
